import { UpdateFormPayload } from '@shared/api/lead-collector';
import { getJWTTokens } from '@shared/libs/local-storage';
import { api } from '@shared/api/axios-instance';
import { AxiosError } from 'axios';

export const updateForm = async ({ id, data, files }: UpdateFormPayload) => {
  try {
    const { accessToken } = getJWTTokens();

    const formData = new FormData();
    formData.append('data', JSON.stringify(data));

    if (files?.length) {
      for (const file of files) {
        formData.append(file.name, file);
      }
    }

    const response = await api.post(`/api/v1/forms/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response;
  } catch (error) {
    return error as AxiosError;
  }
};
